export enum Subscriptions {
  SUBSCRIPTION_A = 'SUBSCRIPTION_A',
  SUBSCRIPTION_B = 'SUBSCRIPTION_B',
  SUBSCRIPTION_C = 'SUBSCRIPTION_C',
}

export enum QCInputType {
  Per_Base_Sequence_Quality = 'Per_Base_Sequence_Quality',
  Basic_Statistics = 'Basic_Statistics',
  Per_Sequence_Qualtity_Score = 'Per_Sequence_Qualtity_Score',
  Total_Sequences = 'Total_Sequences',
  Sequence_Length = 'Sequence_Length',
}

export enum QCCompareType {
  GTE = 'GTE',
  GT = 'GT',
  LT = 'LT',
  LTE = 'LTE',
  EQUAL = 'EQUAL',
}

export enum EmailType {
  REMIND_DONOR_SEND_OUT_KIT = 'remindDonorSendOutKit',
  ASK_DONOR_COMPLETE_FFQ = 'askDonorCompleteFFQ',
  REMIND_DONOR_SEND_OUT_KIT2_WEEKS = 'remindDonorSendOutKit2Weeks',
  NOTICE_DONOR_FFQ_COMPLETED = 'noticeDonorFFQCompleted',
  SAMPLE_RECEIVED_AT_LAB_D2 = 'sampleReceivedAtLabD2',
  ACTIVATION_INCOMPLETE_REMINDER_D31 = 'activationIncompleteReminderD31',
  REPORT_READY_D4 = 'reportReadyD4',
  SAMPLE_RECEIVED_AT_LAB_B1 = 'sampleReceivedAtLabB1',
  REPORT_READY_B2 = 'reportReadyB2',
}

export type Menu =
  | 'Dashboard'
  | 'Admin'
  | 'Customers'
  | 'Project'
  | 'Order'
  | 'Kit'
  | 'Extraction Batch'
  | 'Sequencing Batch'
  | 'Analysis'
  | 'Report'
  | 'Surveys'
  | 'Emails'
  | ' Product';

export enum ModifierType {
  SET_MANDATORY = 'SET_MANDATORY',
  HIDDEN = 'HIDDEN',
}
export enum ModifierProperty {
  HIDDEN = 'HIDDEN',
  MANDATORY = 'MANDATORY',
  OPTIONAL = 'OPTIONAL',
  DISABLED = 'DISABLED',
}

export enum FormEntity {
  PROJECT = 'projectForm',
  ORDER = 'orderForm',
}

export enum ModuleEntity {
  MENU = 'menu',
  PROFILE = 'profile',
  ADMINISTRATOR = 'administrator',
  PROJECT = 'project',
  ORDER = 'order',
  KIT = 'kit',
  EXTRACTION = 'extraction',
  SEQUENCING = 'sequencing',
  ANALYSIS = 'analysis',
  REPORT = 'report',
  SURVEY = 'survey',
  EMAIL = 'email',
  PRODUCT = 'product',
  ORGANIZATION = 'organization',
  DASHBOARD = 'dashboard',
  ALERT = 'alert',
  CUSTOMER = 'customer',
}
